module.exports = __webpack_public_path__ + "static/media/banner.c1c75649.png";